import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface ShareclassNameFormFieldProps {
  placeholder?: string
}

export const ShareclassNameFormField: React.FC<ShareclassNameFormFieldProps> = ({
  placeholder,
}) => {
  const { control, register } = useFormContext<{ shareclass_name: string }>()

  return (
    <FormField
      name="shareclass_name"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Shareclass Name</FormLabel>
              <FormError />
            </div>
            <Input
              {...register('shareclass_name')}
              placeholder={placeholder ?? 'Enter a shareclass name...'}
            />
          </FormItem>
        )
      }}
    />
  )
}
